/* @flow weak */
import { membershipDescriptionFor } from 'groups/lib/groupDisplay';
import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupCreateModal from 'groups/components/GroupCreateModal.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import Groups from 'collections/Groups';
import InlineBlock from 'components/InlineBlock.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import ScrollableArea from 'components/ScrollableArea.jsx';
import Text from 'components/Text.jsx';

import './styles/GroupSelectionDialog.scss';

class GroupSelectionDialog extends React.Component {
  static propTypes = {
    groups: React.PropTypes.oneOfType([
      React.PropTypes.instanceOf(Groups),
      React.PropTypes.arrayOf(React.PropTypes.instanceOf(Group)),
    ]).isRequired,
    onSelect: React.PropTypes.func,
    emptyMessage: React.PropTypes.string,
  };

  static defaultProps = {
    onSelect() /* group */{},
  };

  hide = () => {
    this.props.onRequestHide();
  };

  renderAddGroupOption = () => {
    const dialog = <GroupCreateModal onCreate={this.props.onSelect} />;
    return (
      <ModalTrigger modal={dialog}>
        <li className="GroupSelectionDialog-addGroupItem">
          <Link
            className="GroupSelectionDialog-addGroupItem-link"
            eventElementName="GroupSelectionDialog-addGroupItem-link">
            <Text size="xsmall" weight="semibold">
              Add a new class
            </Text>
          </Link>
        </li>
      </ModalTrigger>
    );
  };

  renderGroupOption = (group) => {
    const subscribersCount = membershipDescriptionFor(group);

    const groupCodeOpt = !group.isStaffClass() && (
      <Text className="GroupSelectionDialog-groupItem-code" color="thunder">
        @{group.getCode()}
      </Text>
    );

    return (
      <li key={group.id} className="GroupSelectionDialog-groupItem">
        <Link
          className="GroupSelectionDialog-groupItem-link"
          onClick={() => this.props.onSelect(group)}
          eventElementName="GroupSelectionDialog-groupItem-link">
          <FlexibleBlock flex="left">
            <FlexibleBlock flex="right">
              <GroupAvatar
                className="GroupSelectionDialog-groupItem-avatar"
                group={group}
              />
              <div>
                <InlineBlock alignv="middle" height={40} fullWidth>
                  <Text className="GroupSelectionDialog-groupItem-name" truncate>
                    <GroupName group={group} />
                  </Text>
                  {groupCodeOpt}
                </InlineBlock>
              </div>
            </FlexibleBlock>
            <InlineBlock alignv="middle" height={40}>
              <Text
                className="GroupSelectionDialog-groupItem-count"
                color="thunder"
                size="xxsmall">
                {subscribersCount}
              </Text>
            </InlineBlock>
          </FlexibleBlock>
        </Link>
      </li>
    );
  };

  renderNoGroups = () => {
    return (
      <li className="GroupSelectionDialog-emptyMessage">
        {this.props.emptyMessage}
      </li>
    );
  };

  render() {
    const { groups } = this.props;

    return (
      <Dialog
        eventScreenName="GroupSelectionDialog"
        {...this.props}
        className="GroupSelectionDialog"
        size="small">
        <BoxBody
          className="GroupSelectionDialog-body"
          divided
          full>
          <ScrollableArea
            className="GroupSelectionDialog-scrollArea"
            showShadows
            useBodyChildrenHeight>
            <ul className="GroupSelectionDialog-list">
              {groups.length === 0 && this.renderNoGroups()}
              {this.renderAddGroupOption()}
              {groups.map(group => this.renderGroupOption(group))}
            </ul>
          </ScrollableArea>
        </BoxBody>
      </Dialog>
    );
  }
}

export default GroupSelectionDialog;



// WEBPACK FOOTER //
// ./src/groups/components/GroupSelectionDialog.jsx